function splitVersion(version) {
  const [major = 0, minor = 0, patch = 0] = (version || '0.0.0').split('.');
  return {
    major,
    minor,
    patch,
  };
}

export function isVersionBefore(
  valueA,
  valueB = getInfoFromQueryParams()?.version
) {
  if (!valueA || !valueB) {
    return null;
  }

  const versionA = splitVersion(valueA);
  const versionB = splitVersion(valueB);
  const parse = (value) => parseInt(value, 10);

  if (versionA.major !== versionB.major) {
    return parse(versionA.major) < parse(versionB.major);
  }

  if (versionA.minor !== versionB.minor) {
    return parse(versionA.minor) < parse(versionB.minor);
  }

  return parse(versionA.patch) < parseInt(versionB.patch);
}

export function parseQuery() {
  const str = window.location.search.substring(1);
  const arg = str.split('&');
  let query = {};

  for (let key in arg) {
    const result = arg[key].split('=');
    if (result[0] !== '') {
      const [key, value] = result;
      query[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  }

  return query;
}

/*
  Nexus passes a urls with params to the iframe in the welcome page.
  For testing, add the following params to the browser url: ?version=3.54.0-SNAPSHOT&versionMm=3.54&edition=PRO&usertype=anonymous&daysToExpiry=90
  For reference, check Welcome page file in nexus-internal.
*/
export function getInfoFromQueryParams() {
  const supportsFeatures = window.location.href.search('[?&]version=') > -1;

  if (supportsFeatures) {
    const params = parseQuery();
    const { major, minor, patch } = splitVersion(params.version);

    return {
      isAnonymous: params.usertype == 'anonymous',
      isAdmin: params.usertype == 'admin',
      isUser: params.usertype == 'normal',
      version: params.version,
      majorVersion: parseInt(major),
      minorVersion: parseInt(minor),
      patchVersion: parseInt(patch),
      isNexus3: major === '3',
      isDebug: params.debug == 'true',
      isOSS: params.edition == 'OSS',
      isPro: params.edition == 'PRO',
      isStarter: params.edition == 'STARTER',
      isEval: params.edition == 'PRO-EVAL', //or maybe 'PRO-UNLICENSED'
    };
  }

  return null;
}

const cookieHandler = (name, value, expire) => {
  const cookie = `${name}=${encodeURI(value)};expires=${expire};`;
  document.cookie = cookie;
};

export function setCookie(name, value) {
  const addMonths = 6;
  const currentDate = new Date();
  const expires = new Date().setMonth(currentDate.getMonth() + addMonths);

  cookieHandler(name, value, new Date(expires).toGMTString());
}

export function deleteCookie(name) {
  const expires = new Date().getTime() - 1000;
  cookieHandler(name, '', new Date(expires).toGMTString());
}

export function getCookie(name) {
  const match = document.cookie.match(
    RegExp('(?:^|;\\s*)' + name + '=([^;]*)')
  );

  return match ? JSON.parse(match[1]) : null;
}

export const dataAttributes = {
  fixVersion: 'data-fix-version',
  unaffectedVersion: 'data-unaffected-version',
  takeOver: 'data-takeover', // Defines if an element should be displayed, meaning that the rest of the page elements should be hidden.
};

export const getFixVersion = (node) =>
  node.getAttribute(dataAttributes.fixVersion);

export const getUnaffectedVersion = (node) =>
  node.getAttribute(dataAttributes.unaffectedVersion);
